import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Title,
  createStyles,
  Avatar,
  Text,
  Select,
  Input,
  Group,
  Button,
  Badge,
  Divider,
  Table,
  Loader,
  Center,
} from "@mantine/core";
import { forwardRef } from "react";

import {
  EpicComapabilitDstu2,
  EpicComapabilitR4,
  EpicComapabilitStu3,
  athenaComapabilitR4,
  cernerComapabilitR4,
  cernerComapabilitdstu2,
  circularPlatformLogo,
  ecwComapabilitr4,
} from "../../utils";
import axios from "axios";
import check from "../../assets/img/Tick.svg";
import cross from "../../assets/img/Close.svg";
import { useMedplum } from "@medplum/react";
import { showNotification } from "@mantine/notifications";
import { InputWrapper } from "@mantine/core/lib/Input/InputWrapper/InputWrapper";
import {
  athenaOneComapabilitr4,
  nextGenComapabilitdstu2,
  nextGenComapabilitr4,
  veradigmComapabilitr4,
} from "./CapabilityService";

const useStyles = createStyles(() => ({
  paper: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "40px",
  },

  title: {
    marginTop: "15px",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "30px",
    color: "#262930",
    paddingTop: "12px",
    paddingBottom: "17px",
  },

  box1: {
    paddingTop: "12px",
  },
  loader: {
    marginTop: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  tableHead: {
    padding: "8px",
    color: "#262930",
    height: "58px",
    backgroundColor: "#BEDEF8",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
  },
  input: { paddingBottom: "18px", width: "70%%" },
  buttonBox: { display: "flex", width: "100%", justifyContent: "flex-start" },
  InputWrapper: {
    paddingTop: "12px",
    width: "71%",
  },
  select: {
    width: "35%",
    paddingTop: "18px",
  },
  selectBox: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },
}));

export const Capabilities = () => {
  const { classes } = useStyles();
  const [metadata, setMetadata] = useState([]);
  const [ehrTypes, setEhrTypes] = useState<string[]>([]);
  const [resource, setResource] = useState<string>();
  const [selectedEHRUrl, setSelectedEHRUrl] = useState<string>("");
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [tableVisible, setTableVisible] = useState(false); // State to track table visibility
  const [selectedEHR, setSelectedEHR] = useState("");

  const medplum = useMedplum();

  const data = [
    {
      image: circularPlatformLogo["epic"],
      label: "EPIC",
      value: "EPIC",
      type: ["R4", "DSTU2", "STU3"],
    },
    {
      image: circularPlatformLogo["athenahealth"],
      label: "AthenaHealth",
      value: "AthenaHealth",

      type: ["R4"],
    },
    {
      image: circularPlatformLogo["cerner"],
      label: "Cerner",
      value: "Cerner",
      type: ["R4", "DSTU2"],
    },
    {
      image: circularPlatformLogo["ecw"],
      label: "eClinicalWorks",
      value: "eClinicalWorks",
      type: ["R4"],
    },
    {
      image: circularPlatformLogo["nextGen"],
      label: "nextGen",
      value: "nextGen",
      type: ["R4","DSTU2"],
    },
    {
      image: circularPlatformLogo["athenahealth"],
      label: "AthenaOne",
      value: "AthenaOne",
      type: ["R4"],
    },
    {
      image: circularPlatformLogo["veradigm"],
      label: "Veradigm",
      value: "Veradigm",
      type: ["R4"],
    },
  ];

  const ehrUrls: Record<string, Record<string, string>> = {
    EPIC: {
      R4: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=epic-capability-r4",
      DSTU2:
        "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=epic-capability-dstu2",
      STU3: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=epic-capability-stu3",
    },
    Cerner: {
      R4: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=cerner-capability-r4",
      DSTU2:
        "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=cerner-capability-dstu2",
    },
    AthenaHealth: {
      R4: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=athena-capability-r4",
    },
    eClinicalWorks: {
      R4: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=ecw-capability-r4",
    },
    nextGen: {
      R4: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=nextGen-capability-r4",
      DSTU2:
        "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=nextGen-capability-dstu2",
    },
    AthenaOne: {
      R4: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=athenaOne-capability-r4",
    }, 
    Veradigm: {
      R4: "https://api-stage.healthconnect.systems/fhir/R4/Bot/$execute?identifier=veradigm-capability-r4",
    },
  };

  interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    image: string;
    label: string;
    description: string;
  }

  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ image, label, description, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group noWrap>
          <Avatar src={image} />
          <div>
            <Text size="sm">{label}</Text>
            <Text size="xs" opacity={0.65}>
              {description}
            </Text>
          </div>
        </Group>
      </div>
    )
  );

  function addInteractionCode(
    capabilityStatement: any,
    resourceType: any,
    interactionCode: any
  ) {
    capabilityStatement?.body?.rest?.forEach((rest: any) => {
      rest?.resource.forEach((resource: any) => {
        if (resource?.type === resourceType) {
          // Check if the interaction code already exists
          if (
            !resource.interaction.find(
              (interaction: any) => interaction?.code === interactionCode
            )
          ) {
            resource?.interaction.push({ code: interactionCode });
          }
        }
      });
    });

    return capabilityStatement;
  }

  const handleEHRSelect = (value: string) => {
    console.log(value,'r')
    const selectedEHRData = data.find((ehr) => ehr.label === value);
    if (selectedEHRData) {
      setTableVisible(false);
      setMetadata([]);
      setSelectedEHRUrl("");
      setResource("");
      setSelectedEHR(value);

      setEhrTypes(selectedEHRData?.type);
    }
  };
  const createRoomPayloadforR4 = {
    eventType: "EPICFhirCapabilityForR4",
  };
  const createRoomPayloadfordtsu2 = {
    eventType: "EPICFhir-Capabilty-For-dstu2",
  };
  const createRoomPayloadforStu3 = {
    eventType: "EPIC-Fhir-Capability-For-R4",
  };
  const createRoomPayloadforCernerdtsu = {
    eventType: "CernerFhir-Capability-For-dstu2",
  };
  const createRoomPayloadforAthenaR4 = {
    eventType: "AthenaFhir-Capabilty-For-dtsu2",
  };
  const createRoomPayloadforCernerr4 = {
    eventType: "Cerner-Fhir-Capability-For-R4",
  };
  const createRoomPayloadforecwr4 = {
    eventType: "ECW-Capabilty-For-r4",
  };
  const createRoomPayloadfornextGenr4 = {
    eventType: "nextGen-Capabilty-For-r4",
  };
  const createRoomPayloadfornextGendstu2= {
    eventType: "nextGen-Capabilty-For-dstu2",
  };
  const createRoomPayloadforAthenaOner4 = {
    eventType: "AthenaOne-Capabilty-For-r4",
  };
  const createRoomPayloadforVeradigm = {
    eventType: "veradigm-Capabilty-For-r4",
  };

  const callFHIRMetadata = async () => {
    try {
      let response;

      if (selectedEHR === "") {
        showNotification({
          color: "red",
          message: "Please Select EHR type and FHIR format",
          autoClose: true,
        });
        return;
      }
      if (!resource) {
        showNotification({
          color: "red",
          message: "Please select the FHIR format",
          autoClose: true,
        });
      }

      if (selectedEHR === "EPIC" && resource === "R4") {
        setIsFetching(true);
        response = await EpicComapabilitR4(medplum, createRoomPayloadforR4);
        setIsFetching(false);
      } else if (selectedEHR === "EPIC" && resource === "DSTU2") {
        setIsFetching(true);
        response = await EpicComapabilitDstu2(
          medplum,
          createRoomPayloadfordtsu2
        );

        setIsFetching(false);
      } else if (selectedEHR === "EPIC" && resource === "STU3") {
        setIsFetching(true);
        response = await EpicComapabilitStu3(medplum, createRoomPayloadforStu3);
        if (response?.status === 200) {
          const updatedResponse = addInteractionCode(
            response,
            "Appointment",
            "create"
          );

          response = updatedResponse;
        }
        setIsFetching(false);
      } else if (selectedEHR === "AthenaHealth" && resource === "R4") {
        setIsFetching(true);
        response = await athenaComapabilitR4(
          medplum,
          createRoomPayloadforAthenaR4
        );
        setIsFetching(false);
      } else if (selectedEHR === "Cerner" && resource === "DSTU2") {
        setIsFetching(true);
        response = await cernerComapabilitdstu2(
          medplum,
          createRoomPayloadforCernerdtsu
        );
        setIsFetching(false);
        
      }
      else if (selectedEHR === "Veradigm" && resource === "R4") {
        setIsFetching(true);
        response = await veradigmComapabilitr4(
          medplum,
          createRoomPayloadforVeradigm
        );
        setIsFetching(false);
      } else if (selectedEHR === "Cerner" && resource === "R4") {
        setIsFetching(true);
        response = await cernerComapabilitR4(
          medplum,
          createRoomPayloadforCernerr4
        );
        setIsFetching(false);
      } else if (selectedEHR === "eClinicalWorks" && resource === "R4") {
        setIsFetching(true);
        response = await ecwComapabilitr4(medplum, createRoomPayloadforecwr4);
        setIsFetching(false);
      } else if (selectedEHR === "AthenaOne" && resource === "R4") {
        setIsFetching(true);
        response = await athenaOneComapabilitr4(
          medplum,
          createRoomPayloadforAthenaOner4
        );
        setIsFetching(false);
      } else if (selectedEHR === "nextGen" && resource === "R4") {
        setIsFetching(true);
        response = await nextGenComapabilitr4(
          medplum,
          createRoomPayloadfornextGenr4
        );
        setIsFetching(false);
      } else if (selectedEHR === "nextGen" && resource === "DSTU2") {
        setIsFetching(true);
        response = await nextGenComapabilitdstu2(
          medplum,
          createRoomPayloadfornextGendstu2
        );
        setIsFetching(false);
      }

      if (response) {
        let data;
        data = response?.body?.rest[0]?.resource.map((resource: any) => ({
          type: resource?.type,
          create: resource?.interaction?.some(
            (inter: any) => inter?.code === "create"
          ),
          read: resource?.interaction?.some(
            (inter: any) => inter?.code === "read"
          ),
          update: resource?.interaction?.some(
            (inter: any) => inter?.code === "update"
          ),
          delete: resource?.interaction?.some(
            (inter: any) => inter?.code === "delete"
          ),
          search: resource?.interaction?.some(
            (inter: any) => inter?.code === "search-type"
          ),
        }));
        setMetadata(data);
        setTableVisible(true);
      }
    } catch (error) {
      console.error("Error fetching FHIR metadata:", error);
      showNotification({
        color: "red",
        message: "Error fetching FHIR metadata. Please try again later.",
        autoClose: true,
      });
    }
  };

  const handleEHRTypeSelect = (value: string) => {
    console.log(value,'val')
    setResource(value);
    if (selectedEHR && value) {
      setSelectedEHRUrl(ehrUrls?.[selectedEHR]?.[value]);
    }
  };

  const tableHeaders = [
    "Resource",
    "Create",
    "Read",
    "Update",
    "Delete",
    "Search",
  ];
  const rows = metadata?.map(
    ({ type, create, read, update, delete: del, search }) => (
      <tr key={type} style={{ padding: "8px" }}>
        <td
          style={{
            padding: "8px",
            color: "#586171",
            fontWeight: "bold",
          }}
        >
          {type}
        </td>
        <td style={{ padding: "8px", alignItems: "center" }}>
          {create ? (
            <Badge color="green">
              <img src={check} alt="Check Icon" />
            </Badge>
          ) : (
            <Badge color="red">
              <img src={cross} alt="Cross Icon" />
            </Badge>
          )}
        </td>
        <td style={{ padding: "8px" }}>
          {read ? (
            <Badge color="green">
              <img src={check} alt="Check Icon" />
            </Badge>
          ) : (
            <Badge color="red">
              <img src={cross} alt="Cross Icon" />
            </Badge>
          )}
        </td>
        <td style={{ padding: "8px" }}>
          {update ? (
            <Badge color="green">
              <img src={check} alt="Check Icon" />
            </Badge>
          ) : (
            <Badge color="red">
              <img src={cross} alt="Cross Icon" />
            </Badge>
          )}
        </td>
        <td style={{ padding: "8px" }}>
          {del ? (
            <Badge color="green">
              <img src={check} alt="Check Icon" />
            </Badge>
          ) : (
            <Badge color="red">
              <img src={cross} alt="Cross Icon" />
            </Badge>
          )}
        </td>
        <td style={{ padding: "8px" }}>
          {search ? (
            <Badge color="green">
              <img src={check} alt="Check Icon" />
            </Badge>
          ) : (
            <Badge color="red">
              <img src={cross} alt="Cross Icon" />
            </Badge>
          )}
        </td>
      </tr>
    )
  );

  return (
    <>
      <Paper className={classes.paper}>
        <Title className={classes.title}>FHIR Server Capabilities</Title>
        {/* <Box className={classes.box1}> */}
        {/* <Box sx={{ display: "flex", width: "70%" }}> */}
        <Box className={classes.selectBox}>
          <Select
            label="EHR Type"
            placeholder="Select EHR"
            itemComponent={SelectItem}
            data={data}
            size="lg"
            radius="md"
            maxDropdownHeight={400}
            nothingFound="Nothing found here"
            filter={(value, item: any) =>
              item?.label?.toLowerCase().includes(value.toLowerCase().trim()) ||
              item?.description
                ?.toLowerCase()
                .includes(value.toLowerCase().trim())
            }
            onChange={(value) => handleEHRSelect(value as string)}
            className={classes.select}
          />
          <Select
            label="FHIR Format"
            placeholder="Select FHIR Format"
            size="lg"
            radius="md"
            maxDropdownHeight={400}
            value={resource}
            data={ehrTypes}
            onChange={(value) => handleEHRTypeSelect(value as string)}
            className={classes.select}
          />
        </Box>

        <Input.Wrapper
          label="HealthConnect API"
          size="lg"
          className={classes.InputWrapper}
        >
          <Input
            placeholder="API URL"
            size="lg"
            radius="md"
            value={selectedEHRUrl}
            onChange={(event) => setSelectedEHR(event.currentTarget.value)}
            disabled={true}
            className={classes.input}
          />
          <Box className={classes.buttonBox}>
            <Button
              onClick={callFHIRMetadata}
              size="md"
              //   disabled={resource ? false : true}
              sx={{ backgroundColor: "#1B75BC" }}
            >
              Check Capabilities
            </Button>
          </Box>
        </Input.Wrapper>
        {isFetching ? (
          <Center className={classes.loader}>
            <Loader />
          </Center>
        ) : (
          <Box>
            {tableVisible && (
              <Box sx={{ paddingTop: "18px" }}>
                <Table horizontalSpacing="sm" verticalSpacing="sm">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, index) => (
                        <th
                          className={classes.tableHead}
                          key={index}
                          style={{
                            borderTopLeftRadius: index === 0 ? "4px" : "0",
                            borderBottomLeftRadius: index === 0 ? "4px" : "0",
                            borderTopRightRadius:
                              index === header.length - 1 ? "4px" : "0",

                            borderBottomRightRadius:
                              index === header.length - 1 ? "4px" : "0",
                          }}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>{rows}</tbody>
                </Table>
              </Box>
            )}
          </Box>
        )}

        {/* </Box> */}
      </Paper>
    </>
  );
};

export default Capabilities;
